// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kiHrCS{position:relative;height:100%}.sX3BuV{font-size:22px}.JRyRol{width:30px;height:30px}.l9krWR{visibility:hidden}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `kiHrCS`,
	"title": `sX3BuV`,
	"icon": `JRyRol`,
	"hidden": `l9krWR`
};
export default ___CSS_LOADER_EXPORT___;
